import { html, type TemplateResult } from '@design.estate/dees-element';

/**
 * The modelgrid icon: six rounded squares over a chat bubble on a tile, the
 * drawing of assets/logo/modelgrid-app-icon.svg in the colours it is given.
 */
export const renderIcon = (sizeArg: number, tileArg: string, glyphArg: string): TemplateResult => html`<svg
  class="icon"
  width=${sizeArg}
  height=${sizeArg}
  viewBox="0 0 64 64"
  aria-hidden="true"
>
  <rect width="64" height="64" rx="14" fill=${tileArg}></rect>
  <g fill=${glyphArg} transform="translate(15.8 13.55) scale(.9)">
    <rect width="10" height="10" rx="3"></rect>
    <rect x="13" width="10" height="10" rx="3" opacity=".75"></rect>
    <rect x="26" width="10" height="10" rx="3" opacity=".5"></rect>
    <rect y="13" width="10" height="10" rx="3" opacity=".75"></rect>
    <rect x="13" y="13" width="10" height="10" rx="3"></rect>
    <rect x="26" y="13" width="10" height="10" rx="3" opacity=".75"></rect>
    <path d="M0 29a3 3 0 0 1 3-3h30a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H12l-7 5v-5H3a3 3 0 0 1-3-3z"></path>
  </g>
</svg>`;
